module.exports = __webpack_public_path__ + "img/logo.8b1566b9.webp";